/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { forwardRef } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// Material Dashboard 2 React components
import MDTypography from "components/MDTypography";

// Custom styles for MDSwitch
import MDSwitchRoot from "components/MDSwitch/MDSwitchRoot";

const MDSwitch = forwardRef(({ variant, color, checked, label, ...rest }, ref) => (
    <>
        {label && (
            <MDTypography variant="button" fontWeight="medium" color="text">
                {label}
            </MDTypography>
        )}
        <MDSwitchRoot
            {...rest}
            ref={ref}
            checked={checked}
            ownerState={{ color, variant }}
        />
    </>
));

// Setting default values for the props of MDSwitch
MDSwitch.defaultProps = {
    variant: "contained",
    color: "info",
    checked: false,
    label: "",
};

// Typechecking props for the MDSwitch
MDSwitch.propTypes = {
    variant: PropTypes.oneOf(["contained", "gradient"]),
    color: PropTypes.oneOf([
        "primary",
        "secondary",
        "info",
        "success",
        "warning",
        "error",
        "light",
        "dark",
    ]),
    checked: PropTypes.bool,
    label: PropTypes.string,
};

export default MDSwitch;
